export default function ($http) {
    return function () {
        return $http.get('api/accountGroups/').then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/accountGroups/services/list/getAccountGroups.js